// "Hall at Rest" — Symphony's empty-landing backdrop.
//
// Just the warm room. Earlier passes layered a Maestro focal mark
// (halo + ring + rosewood ink-dot) at the upper-center to suggest
// the conductor waiting; in practice it read as a stray UI dot in
// the middle of the chat area rather than ambient presence — see
// the missing-conversation hero where the brand mark earns its
// focal weight with motion and copy. Pulling the mark leaves the
// stage-glow rect alone to do the warmth.

const VIEWBOX_W = 1100;
const VIEWBOX_H = 700;

export function SymphonyEnsemble({ dim = false }: { awake?: boolean; dim?: boolean }) {
  return (
    <svg
      viewBox={`0 0 ${VIEWBOX_W} ${VIEWBOX_H}`}
      preserveAspectRatio="xMidYMid slice"
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        transition: 'opacity 1400ms ease',
        opacity: dim ? 0.22 : 0.38,
        pointerEvents: 'none',
      }}
      aria-hidden
    >
      <defs>
        {/* Stage glow — broad warm pool rising up the canvas. On a
            cream field, the glow must be subtle: a hint of brass
            warmth rather than a visible orange wash. */}
        <radialGradient id="symphony-stage-glow" cx="50%" cy="70%" r="62%">
          <stop offset="0%" stopColor="var(--ds-fill-accent-brand-default)" stopOpacity="0.07" />
          <stop offset="40%" stopColor="var(--ds-green-neon-300)" stopOpacity="0.035" />
          <stop offset="80%" stopColor="var(--ds-green-neon-600)" stopOpacity="0.012" />
          <stop offset="100%" stopColor="var(--ds-black)" stopOpacity="0" />
        </radialGradient>
      </defs>

      <rect x={0} y={0} width={VIEWBOX_W} height={VIEWBOX_H} fill="url(#symphony-stage-glow)" />
    </svg>
  );
}
